import { JSX, SVGProps } from 'react';

export const CircleCheck = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg
    width={27}
    height={27}
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.19718 13.6524L11.6972 17.1524L18.6972 10.1524M25.1139 13.6524C25.1139 20.0957 19.8905 25.3191 13.4472 25.3191C7.00386 25.3191 1.78052 20.0957 1.78052 13.6524C1.78052 7.20906 7.00386 1.98572 13.4472 1.98572C19.8905 1.98572 25.1139 7.20906 25.1139 13.6524Z"
      stroke="#FE5E44"
      strokeWidth={2.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
